import { render } from "./feedback-page-satisfactory.vue?vue&type=template&id=2d523f73&scoped=true"
import script from "./feedback-page-satisfactory.vue?vue&type=script&lang=js"
export * from "./feedback-page-satisfactory.vue?vue&type=script&lang=js"

import "./feedback-page-satisfactory.vue?vue&type=style&index=0&id=2d523f73&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d523f73"]])

export default __exports__